export const BTN_MUESTRA_LISTA_MATERIALES = `
    <a class="text-info" style="cursor: pointer" onclick="siimmex.descargas_dirigidas.onClickBtnMostrarListaMateriales()">
        <i class="fas fa-exclamation-circle"></i>
    </a>`;

export const LOADING_INFO_MATERIAL_EN_DESCARGO_ELEMENT = `
    <div class="spinner-grow spinner-grow-sm" role="status">
        <span class="sr-only">Loading...</span>
    </div>`;

export const headerDetalleDataTable = document.getElementById("tituloTablaDetalle");

export const ALERT_ESTE_MATERIAL_NO_TIENE_LISTA = `
    <div>
        <div class='d-flex align-items-center'>
            <i class='fas fa-exclamation-circle text-danger mr-2'></i>
            <span>Este material no tiene una<br/>lista de materiales valida</span>
        </div>
    </div>`;

/**
 * Establece el titulo del material "En descarga"
 * @param {string} material Material a mostrar
 */
export const setLabelMaterialEnDescarga = (material) => {
    headerDetalleDataTable.innerHTML = LOADING_INFO_MATERIAL_EN_DESCARGO_ELEMENT;
    headerDetalleDataTable.previousElementSibling.innerText = "";
    if (material.length !== 0) {
        headerDetalleDataTable.innerHTML = `${BTN_MUESTRA_LISTA_MATERIALES} ${material}`;
    }
};
